import { render, staticRenderFns } from "./ViewWeek.vue?vue&type=template&id=27a4ae4f"
import script from "./ViewWeek.vue?vue&type=script&lang=js"
export * from "./ViewWeek.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports